"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PINNBET_DOMAIN = "online.pinnbet.admiral.elbet.com";
var translation = window['langArr'][window['language']];
var specialDomains = [
    "online.zb.elbet.com",
    "online.weldmag.elbet.com",
    "online.maxbet.mne.elbet.com",
    "online.dev.elbetdev.com",
    "online.jokker.elbetdev.com"
];
function isSpecialDomain(host) {
    return specialDomains.some(function (d) { return host === d || host.endsWith("." + d); });
}
var VersionSwitcher = (function () {
    function VersionSwitcher() {
        var _this = this;
        this.htmlRenderElem = document.querySelector('.switcher');
        this._onLbBall = function (ev) {
            _this.ensureDrawState();
            var e = ev;
            if (!e || !e.detail) {
                console.warn('[lb_ball] no detail');
                return;
            }
            var w = window;
            var num = Number(e.detail.number);
            var idx = Number(e.detail.index);
            if (!w.drawnNumbersForRound) {
                var r = w.currentDrawRoundToday || w.todayRoundId;
                if (r != null && r !== '') {
                    w.drawnNumbersForRound = String(r);
                }
            }
            if (idx === 1 && Array.isArray(w.drawnNumbers) && w.drawnNumbers.length === 0) {
                w.drawnBalls = 0;
                w.drawnNumbers = [];
                w.drawnOddBalls = 0;
                w.drawnEvenBalls = 0;
                w.drawnColors = { red: 0, blue: 0, green: 0, brown: 0, yellow: 0, black: 0, orange: 0, purple: 0 };
            }
            if (Array.isArray(w.drawnNumbers) && typeof idx === 'number' && idx > 0) {
                if (w.drawnNumbers.length >= idx) {
                    return;
                }
            }
            w.drawnNumbers.push(num);
            w.drawnBalls = (w.drawnBalls | 0) + 1;
            var color = e.detail.color;
            w.drawnColors[color] = (w.drawnColors[color] || 0) + 1;
            _this.isOdd(num) ? w.drawnOddBalls++ : w.drawnEvenBalls++;
            window.dispatchEvent(new CustomEvent('update_tickets'));
            if (idx === 35 || (Array.isArray(w.drawnNumbers) && w.drawnNumbers.length >= 35)) {
                var roundNow = w.drawnNumbersForRound || w.currentDrawRoundToday || w.todayRoundId;
                if (roundNow != null && roundNow !== '') {
                    w.lastFinishedDrawRoundToday = String(roundNow);
                    w.drawnNumbersForRound = String(roundNow);
                }
            }
        };
        this._onLbState = function (ev) {
            _this.ensureDrawState();
            var e = ev;
            var balls = (e && e.detail && Array.isArray(e.detail.balls)) ? e.detail.balls : [];
            var w = window;
            if (!balls.length) {
                window.dispatchEvent(new CustomEvent('tickets-present'));
                window.dispatchEvent(new CustomEvent('update_tickets'));
                return;
            }
            var palette = ['red', 'green', 'blue', 'purple', 'brown', 'yellow', 'orange', 'black'];
            var currentLen = Array.isArray(w.drawnNumbers) ? w.drawnNumbers.length : 0;
            if (balls.length > currentLen) {
                for (var i = currentLen; i < balls.length; i++) {
                    var num = Number(balls[i]);
                    if (isNaN(num))
                        continue;
                    w.drawnNumbers.push(num);
                    w.drawnBalls = (w.drawnBalls | 0) + 1;
                    var colorKey = palette[(num - 1) % palette.length];
                    w.drawnColors[colorKey] = (w.drawnColors[colorKey] || 0) + 1;
                    _this.isOdd(num) ? w.drawnOddBalls++ : w.drawnEvenBalls++;
                }
            }
            window.dispatchEvent(new CustomEvent('tickets-present'));
            window.dispatchEvent(new CustomEvent('update_tickets'));
        };
        this._onLbNewRound = function (_ev) {
            _this.resetDrawState();
            window.dispatchEvent(new CustomEvent('update_tickets'));
        };
        this.ensureDrawState = function () {
            if (!Array.isArray(window.drawnNumbers))
                window.drawnNumbers = [];
            if (typeof window.drawnBalls !== 'number')
                window.drawnBalls = 0;
            if (typeof window.drawnOddBalls !== 'number')
                window.drawnOddBalls = 0;
            if (typeof window.drawnEvenBalls !== 'number')
                window.drawnEvenBalls = 0;
            if (!window.drawnColors || typeof window.drawnColors !== 'object') {
                window.drawnColors = {
                    red: 0, blue: 0, green: 0, brown: 0,
                    yellow: 0, black: 0, orange: 0, purple: 0
                };
            }
        };
        this.resetDrawState = function () {
            window.drawnBalls = 0;
            window.drawnNumbers = [];
            window.drawnOddBalls = 0;
            window.drawnEvenBalls = 0;
            window.drawnNumbersForRound = '';
            window.drawnColors = {
                red: 0, blue: 0, green: 0, brown: 0,
                yellow: 0, black: 0, orange: 0, purple: 0
            };
        };
    }
    VersionSwitcher.prototype.specificDomainChanges = function () {
        switch (window.location.hostname) {
            case PINNBET_DOMAIN:
                if (window.V4 == 3) {
                    var gamePlayHolder = document.getElementsByClassName("game-holder-bar main-lb-game-holder-bar")[0];
                    gamePlayHolder.classList.remove("game-holder-bar");
                    gamePlayHolder.innerHTML = "<div class=\"element-header game-holder-bar main-lb-game-holder-bar\" style=\"align-items: center;\">\n              <div style='width:100%;display: flex;justify-content: left;align-items: center;' >" + translation['regional_jackpot'] + ": <div id='regionalJackpotDOM'></div> </div>\n              <div style='width:31%;justify-content: center;align-items: center;text-align: center;'>Lucky Balls</div>\n              <div class=\"jackpot-informer\"> " + translation['jackpot'] + " : <span id=\"lbJackpotValue\"></span> " + translation['jackpot_code'] + " : <span id=\"lbJackpotCode\" ></span> </div>\n              <span style=\"width:100%;justify-content: right;align-items: center;text-align: right;\" id=\"jackpotDisplay\"></span>\n          </div>";
                }
                break;
            case ZB_DOMAIN:
                var gamePlayHolder = document.getElementsByClassName("game-holder-bar main-lb-game-holder-bar")[0];
                gamePlayHolder.classList.remove("game-holder-bar");
                gamePlayHolder.innerHTML = "<div class=\"element-header game-holder-bar main-lb-game-holder-bar\" style=\"align-items: center;\">\n              <div style='width:100%;display: flex;justify-content: left;align-items: center;' >" + translation['regional_jackpot'] + ": <div id='regionalJackpotDOM'></div> </div>\n              <div style='width:31%;justify-content: center;align-items: center;text-align: center;'>Lucky Balls</div>\n              <div class=\"jackpot-informer\"> " + translation['jackpot'] + " : <span id=\"lbJackpotValue\"></span> " + translation['jackpot_code'] + " : <span id=\"lbJackpotCode\" ></span> </div>\n              <span style=\"width:100%;justify-content: right;align-items: center;text-align: right;\" id=\"jackpotDisplay\"></span>\n          </div>";
                break;
            case WELDMAG_DOMAIN:
                if (window.V4 == 3) {
                    var gamePlayHolder = document.getElementsByClassName("game-holder-bar main-lb-game-holder-bar")[0];
                    gamePlayHolder.classList.remove("game-holder-bar");
                    gamePlayHolder.innerHTML = "<div class=\"element-header game-holder-bar main-lb-game-holder-bar\" style=\"align-items: center;\">\n              <div style='width:100%;display: flex;justify-content: left;align-items: center;' >" + translation['weldmag_regional_jackpot'] + ": <div id='regionalJackpotDOM'></div> </div>\n              <div style='width:31%;justify-content: center;align-items: center;text-align: center;'>Lucky Balls</div>\n              <div class=\"jackpot-informer\"> " + translation['jackpot'] + " : <span id=\"lbJackpotValue\"></span> " + translation['jackpot_code'] + " : <span id=\"lbJackpotCode\" ></span> </div>\n              <span style=\"width:100%;justify-content: right;align-items: center;text-align: right;\" id=\"jackpotDisplay\"></span>\n          </div>";
                }
                break;
        }
    };
    VersionSwitcher.prototype.getLuckyBallsGameName = function () {
        if (window.location.href.indexOf('ciws_prod_evlbet_bam') === -1) {
            return 'Lucky Balls';
        }
        var gameName = window['BingoGameName'] || window['Bingo_GameName'] || window['Bingo49_GameName'];
        if (gameName !== undefined && gameName !== null && String(gameName).trim() !== '') {
            return String(gameName).trim();
        }
        return 'Lucky Balls';
    };
    VersionSwitcher.prototype.switch = function (v4Game) {
        if ((v4Game === 4 && !/terminal/.test(window.location.href) && !/electron=true/.test(window.location.href))
            || location.hostname == 'online.soccer2.elbet.com' || location.hostname == 'online.stage.soccer.elbet.com') {
            this.attachMessagePost();
            var ticketDomElement = document.getElementById('ticketsScroll');
            if (ticketDomElement) {
                ticketDomElement.classList.add('ticketObject');
            }
            var eleBody = 'element-body-for-object';
            var iOS = /iPhone|iPod/.test(navigator.userAgent);
            if (iOS === true) {
                eleBody = 'element-body-iphone-for-object ';
            }
            var gameConfigName = this.getLuckyBallsGameName();
            this.htmlRenderElem.classList.add('video-object');
            this.htmlRenderElem.innerHTML = '';
            this.htmlRenderElem.innerHTML = "\n        <div class=\"" + eleBody + (" video-for-object\">\n          <div class=\"element-header game-holder-bar main-lb-game-holder-bar\">\n          " + gameConfigName + " <div class=\"jackpot-informer\"> " + translation['jackpot'] + " : <span id=\"lbJackpotValue\"></span> " + translation['jackpot_code'] + " : <span id=\"lbJackpotCode\" ></span> </div><span id=\"jackpotDisplay\"></span>\n          </div>\n          <div class=\"element-body\" style=\"height:100%\">\n            <object width=\"100%\" height=\"100%\" data=\"\" id=\"gamePlay\"></object>\n          </div>\n        </div>");
            var companyParam = window.__elbetCompany ? '&company=' + encodeURIComponent(window.__elbetCompany) : '';
            if (location.hostname == 'online.soccer2.elbet.com') {
                $('#gamePlay').attr('data', 'https://' + GAMES_DOMAIN + '/lucky-balls-tv/index.html?r=v&d=online.soccer2.elbet.com' + companyParam);
            }
            else if (location.hostname == 'online.stage.soccer.elbet.com') {
                $('#gamePlay').attr('data', 'https://' + GAMES_DOMAIN + '/lucky-balls-tv/index.html?r=v&d=online.stage.soccer.elbet.com' + companyParam);
            }
            else {
                window.lang ? $('#gamePlay').attr('data', 'https://' + GAMES_DOMAIN + '/lucky-balls/index.html?referer=' + window.location.host + '&lang=' + window.lang + companyParam) :
                    $('#gamePlay').attr('data', 'https://' + GAMES_DOMAIN + '/lucky-balls/index.html?referer=' + window.location.host + companyParam);
            }
            var UITabs = document.getElementById('tabs');
            if (UITabs)
                UITabs.style.marginTop = "33px";
        }
        else if (v4Game === 5) {
            this.switchForceV5(window.__elbetCompany || '');
        }
    };
    VersionSwitcher.prototype.switchForceV5 = function (company) {
        window.v5 = true;
        this.attachMessagePost();
        var ticketDomElement = document.getElementById('ticketsScroll');
        if (ticketDomElement) {
            ticketDomElement.classList.add('ticketObject');
        }
        var eleBody = 'element-body-for-object';
        var iOS = /iPhone|iPod/.test(navigator.userAgent);
        if (iOS === true) {
            eleBody = 'element-body-iphone-for-object ';
        }
        this.htmlRenderElem.classList.add('video-object');
        this.htmlRenderElem.innerHTML = '';
        this.htmlRenderElem.innerHTML = "\n        <div class=\"" + eleBody + (" video-for-object\">\n          <div class=\"element-header game-holder-bar main-lb-game-holder-bar\">\n          Lucky Balls <div class=\"jackpot-informer\"> " + translation['jackpot'] + " : <span id=\"lbJackpotValue\"></span> " + translation['jackpot_code'] + " : <span id=\"lbJackpotCode\" ></span> </div><span id=\"jackpotDisplay\"></span>\n          </div>\n          <div class=\"element-body\" style=\"height:100%\">\n            <object style=\"position:absolute;top : -2000px;\" width=\"100%\" height=\"100%\" data=\"\" id=\"gamePlay\"></object>\n             <!-- NOVO: iframe za v5 -->\n                <iframe \n                  id=\"gamePlayV5\"\n                  src=\"\"\n                  style=\"width:100%; height:100%; border:0;\"\n                  allow=\"fullscreen; autoplay; encrypted-media\"\n                ></iframe>\n              </div>\n            </div>\n          </div>\n        </div>");
        var companyParam = window.__elbetCompany ? '&company=' + encodeURIComponent(window.__elbetCompany) : '';
        window.lang ? $('#gamePlay').attr('data', 'https://' + GAMES_DOMAIN + '/lucky-balls/index.html?referer=' + window.location.host + '&lang=' + window.lang + companyParam) :
            $('#gamePlay').attr('data', 'https://' + GAMES_DOMAIN + '/lucky-balls/index.html?referer=' + window.location.host + companyParam);
        var effectiveCompany = window.__elbetCompany ? window.__elbetCompany : company;
        console.log("Launch v5 visuals for ", effectiveCompany);
        var constructLink = 'https://launcher.elbet.com/virtuals/lucky-balls/v5/index.html?company=' + encodeURIComponent(effectiveCompany);
        $('#gamePlayV5').attr('src', constructLink);
        var UITabs = document.getElementById('tabs');
        if (UITabs)
            UITabs.style.marginTop = "33px";
    };
    VersionSwitcher.prototype.attachMessagePost = function () {
        if (isSpecialDomain(window.location.hostname)) {
            this.attachSocketBallFlow();
            this.attachIframeAuxFlow();
            console.log('[attach] special domain -> socket lb_ball + iframe AUX (get_tickets/response_gameplay)');
            return;
        }
        var self = this;
        window.addEventListener('message', function (event) {
            if (event.data.type === 'ball_drawn') {
                if (event.data.serialNo >= 1 && event.data.serialNo < 37) {
                    window.currentGameDisplayStatus = 1;
                    if (event.data.roundId != null && event.data.roundId !== '') {
                        window.currentDrawRoundToday = String(event.data.roundId);
                        window.todayRoundId = String(event.data.roundId);
                        window.drawnNumbersForRound = String(event.data.roundId);
                    }
                    else if (!window.drawnNumbersForRound) {
                        var r = window.currentDrawRoundToday || window.todayRoundId;
                        if (r != null && r !== '') {
                            window.drawnNumbersForRound = String(r);
                        }
                    }
                    window.drawnBalls = 0;
                    window.drawnNumbers = [];
                    window.drawnOddBalls = 0;
                    window.drawnEvenBalls = 0;
                    window.drawnColors = {
                        red: 0,
                        blue: 0,
                        green: 0,
                        brown: 0,
                        yellow: 0,
                        black: 0,
                        orange: 0,
                        purple: 0
                    };
                    var entity_1 = ['red', 'green', 'blue', 'pink', 'brown', 'yellow', 'orange', 'black'];
                    event.data.drawnBalls.forEach(function (element) {
                        window.drawnNumbers.push(element.number);
                        window.drawnBalls++;
                        window.drawnColors[entity_1[element.color]]++;
                        if (self.isOdd(Number(element.number))) {
                            window.drawnOddBalls++;
                        }
                        else {
                            window.drawnEvenBalls++;
                        }
                    });
                    var ticketsEvent = new CustomEvent('update_tickets');
                    window.dispatchEvent(ticketsEvent);
                    if (typeof window.refreshResultsPanelFromCache === 'function') {
                        window.refreshResultsPanelFromCache();
                    }
                    if (Number(event.data.serialNo) === 35
                        || (Array.isArray(event.data.drawnBalls) && event.data.drawnBalls.length >= 35)) {
                        var roundNow = window.drawnNumbersForRound
                            || window.currentDrawRoundToday
                            || window.todayRoundId;
                        if (roundNow != null && roundNow !== '') {
                            window.lastFinishedDrawRoundToday = String(roundNow);
                            window.drawnNumbersForRound = String(roundNow);
                        }
                    }
                }
                else if (event.data.serialNo === 20) { }
                else {
                    console.error('Invalid ball number provided');
                }
            }
            if (typeof event.data.type !== 'undefined' && event.data.type === 'get_tickets') {
                var getTicketEvent = new CustomEvent('get_tickets');
                window.dispatchEvent(getTicketEvent);
                window.updateResultsV4();
            }
            if (typeof event.data.type !== 'undefined' && event.data.type === 'response_gameplay') {
                var response = event.data.response;
                if (response) {
                    window.__luckyballsV4Gameplay = response;
                    window.responseHandler = window.responseHandler || { gameResults: {} };
                    window.responseHandler.getGame = Object.assign({}, window.responseHandler.getGame || {}, response);
                }
                if (response && response.GameStatus != null) {
                    window.currentGameDisplayStatus = response.GameStatus;
                }
                if (response && response.ID_Today != null && response.ID_Today !== '') {
                    window.currentDrawRoundToday = String(response.ID_Today);
                    window.todayRoundId = String(response.ID_Today);
                    if (String(response.GameStatus) === '1') {
                        window.drawnNumbersForRound = String(response.ID_Today);
                    }
                }
                window['gameDisplayV4'](response);
                if (response && String(response.GameStatus) === '1') {
                    if (typeof window.refreshResultsPanelFromCache === 'function'
                        && window.responseHandler
                        && window.responseHandler.gameResults) {
                        window.refreshResultsPanelFromCache();
                    }
                    else if (typeof window.updateResultsV4 === 'function') {
                        window.updateResultsV4();
                    }
                }
                else if (response) {
                    if (typeof window.refreshResultsPanelFromCache === 'function'
                        && window.responseHandler
                        && window.responseHandler.gameResults) {
                        window.refreshResultsPanelFromCache();
                    }
                    else if (typeof window.updateResultsV4 === 'function') {
                        window.updateResultsV4();
                    }
                }
                var localHelper = event.data.drawnBalls;
                var localListener = function () {
                    window.drawnBalls = 0;
                    window.drawnNumbers = [];
                    window.drawnOddBalls = 0;
                    window.drawnEvenBalls = 0;
                    window.drawnColors = {
                        red: 0,
                        blue: 0,
                        green: 0,
                        brown: 0,
                        yellow: 0,
                        black: 0,
                        orange: 0,
                        purple: 0
                    };
                    var entity = ['red', 'green', 'blue', 'pink', 'brown', 'yellow', 'orange', 'black'];
                    localHelper.forEach(function (element) {
                        window.drawnNumbers.push(element.number);
                        window.drawnBalls++;
                        window.drawnColors[entity[element.color]]++;
                        if (self.isOdd(Number(element.number))) {
                            window.drawnOddBalls++;
                        }
                        else {
                            window.drawnEvenBalls++;
                        }
                    });
                    var getTicketEvent = new CustomEvent('update_tickets');
                    window.dispatchEvent(getTicketEvent);
                    window.removeEventListener('tickets-present', localListener);
                };
                window.addEventListener('tickets-present', localListener, false);
            }
        }, false);
    };
    VersionSwitcher.prototype.attachSocketBallFlow = function () {
        window.removeEventListener('lb_new_round', this._onLbNewRound);
        window.addEventListener('lb_new_round', this._onLbNewRound);
        window.removeEventListener('lb_state', this._onLbState);
        window.addEventListener('lb_state', this._onLbState);
        window.removeEventListener('lb_ball', this._onLbBall);
        window.addEventListener('lb_ball', this._onLbBall);
        console.log('[attach] lb_ball, lb_new_round & lb_state listeners on current window');
    };
    VersionSwitcher.prototype.attachIframeAuxFlow = function () {
        window.addEventListener('message', function (event) {
            if (typeof event.data.type !== 'undefined' && event.data.type === 'get_tickets') {
                var getTicketEvent = new CustomEvent('get_tickets');
                window.dispatchEvent(getTicketEvent);
                window.updateResultsV4();
            }
            if (typeof event.data.type !== 'undefined' && event.data.type === 'response_gameplay') {
                var response = event.data.response;
                if (response) {
                    window.__luckyballsV4Gameplay = response;
                    window.responseHandler = window.responseHandler || { gameResults: {} };
                    window.responseHandler.getGame = Object.assign({}, window.responseHandler.getGame || {}, response);
                }
                if (response && response.GameStatus != null) {
                    window.currentGameDisplayStatus = response.GameStatus;
                }
                if (response && response.ID_Today != null && response.ID_Today !== '') {
                    window.currentDrawRoundToday = String(response.ID_Today);
                    window.todayRoundId = String(response.ID_Today);
                    if (String(response.GameStatus) === '1') {
                        window.drawnNumbersForRound = String(response.ID_Today);
                    }
                }
                window['gameDisplayV4'](response);
                if (response && String(response.GameStatus) === '1') {
                    if (typeof window.refreshResultsPanelFromCache === 'function'
                        && window.responseHandler
                        && window.responseHandler.gameResults) {
                        window.refreshResultsPanelFromCache();
                    }
                    else if (typeof window.updateResultsV4 === 'function') {
                        window.updateResultsV4();
                    }
                }
                else if (response) {
                    if (typeof window.refreshResultsPanelFromCache === 'function'
                        && window.responseHandler
                        && window.responseHandler.gameResults) {
                        window.refreshResultsPanelFromCache();
                    }
                    else if (typeof window.updateResultsV4 === 'function') {
                        window.updateResultsV4();
                    }
                }
                window.dispatchEvent(new CustomEvent('tickets-present'));
                window.dispatchEvent(new CustomEvent('update_tickets'));
            }
        }, false);
    };
    VersionSwitcher.prototype.isInteger = function (n) {
        return n === parseInt(n);
    };
    VersionSwitcher.prototype.isOdd = function (n) {
        return this.isInteger(n) && (n % 2 !== 0);
    };
    return VersionSwitcher;
}());
exports.default = VersionSwitcher;



//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/ts/version-switcher/version-switcher.ts
// module id = 1215
// module chunks = 0